import React, { useEffect, useState } from "react";
import { Container, Table, Card, Spinner } from "react-bootstrap";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import bannerImage from "../../Images/Banner/apply-online.webp";

const ShowApplication = () => {
    const [applications, setApplications] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchApplications = async () => {
            try {
                // Relative path fetch ensures no CORS issue when React is on same domain
                const response = await fetch("https://isbmuniversity.edu.in/form-api/get-applications.php");
                if (!response.ok) throw new Error("Network response not OK");
                const data = await response.json();
                if (data.success) setApplications(data.applications || []);
                else alert("Failed to fetch applications");
            } catch (error) {
                console.error("Fetch error:", error);
                alert(
                    "Error fetching applications. Make sure API is reachable and CORS is configured."
                );
            } finally {
                setLoading(false);
            }
        };
        fetchApplications();
    }, []);

    const renderDocuments = (documents) => {
        if (!documents) return null;
        try {
            const docs = JSON.parse(documents);
            return Object.entries(docs).map(([key, path]) => (
                <div key={key}>
                    <a
                        href={path.startsWith("http") ? path : `/${path}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {key}
                    </a>
                </div>
            ));
        } catch (err) {
            console.error("Document JSON parse error:", err);
            return null;
        }
    };

    return (
        <>
            <Topnav />

            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="container-xxl">
                        <div className="section-hero-content">
                            <h1>Apply Online</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                                        Home
                                    </a>
                                </li>
                                <li className="breadcrumb-item active text-white" aria-current="page">
                                    Apply Online
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section className="ptb-50">
                <Container>
                    <h2 className="mb-4">Submitted Applications</h2>
                    <Card>
                        <Card.Body>
                            {loading ? (
                                <div className="text-center">
                                    <Spinner animation="border" variant="primary" />
                                </div>
                            ) : applications.length === 0 ? (
                                <p>No applications found.</p>
                            ) : (
                                <Table striped bordered hover responsive>
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Full Name</th>
                                            <th>Email</th>
                                            <th>Telephone</th>
                                            <th>Course</th>
                                            <th>Level</th>
                                            <th>Father Name</th>
                                            <th>Gender</th>
                                            <th>Academic Details</th>
                                            <th>Pay Amount</th>
                                            <th>Documents</th>
                                            <th>Comments</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {applications.map((app) => (
                                            <tr key={app.id}>
                                                <td>{app.id}</td>
                                                <td>{app.full_name || "-"}</td>
                                                <td>{app.email || "-"}</td>
                                                <td>{app.telephone || "-"}</td>
                                                <td>{app.course || "-"}</td>
                                                <td>{app.level || "-"}</td>
                                                <td>{app.father_name || "-"}</td>
                                                <td>{app.gender || "-"}</td>
                                                <td>
                                                    <strong>Degree:</strong> {app.degree || "-"} <br />
                                                    <strong>Specialization:</strong> {app.specialization || "-"} <br />
                                                    <strong>Institution:</strong> {app.institution || "-"} <br />
                                                    <strong>Exam Month:</strong> {app.exam_month || "-"} <br />
                                                    <strong>Exam Year:</strong> {app.exam_year || "-"} <br />
                                                    <strong>Results:</strong> {app.results || "-"} <br />
                                                    <strong>Work Exp:</strong> {app.work_experience || "-"}
                                                </td>
                                                <td>{app.pay_amount || "-"}</td>
                                                <td>{renderDocuments(app.documents)}</td>
                                                <td>{app.comments || "-"}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            )}
                        </Card.Body>
                    </Card>
                </Container>
            </section>

            <Footer />
        </>
    );
};

export default ShowApplication;
